import moment from "moment";
import React from "react";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBI1 } from "../../../../../redux/app/crb/groups/crb-i";
import { commonUtils } from "../../../../../redux/_common";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBI1PreviewProps = OwnProps;
function CRBI1Preview(props: CRBI1PreviewProps) {
	const crbRecord = props.crbRecord as TCRBI1;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "I", 26, renderItem26()],
					[null, null, 27, renderItem27()],
					[null, null, 28, renderItem28()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderItem26() {
		const { timeOfOccurence } = crbRecord.item26;
		const { placeOfBallast } = crbRecord.item26P1;
		const formSelectedDate = moment(crbRecord.selectedDate).format(
			"YYYY-MM-DD"
		);
		const dateTimeLocal = `${formSelectedDate}T${timeOfOccurence}:00${crbRecord.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);
		if (placeOfBallast.place === "IN_PORT") {
			return (
				<>
					<h4 className="font-medium uppercase">
						Time of Occurrence: {utcTime.format("HH:mm")} hrs (UTC) (
						{timeOfOccurence} SMT)
					</h4>
					<h4 className="font-medium uppercase">
						Discharged at: {placeOfBallast.portName}
					</h4>
				</>
			);
		}
		if (placeOfBallast.place === "AT_SEA") {
			return (
				<>
					<h4 className="font-medium uppercase">
						Time of Occurrence: {utcTime.format("HH:mm")} hrs (UTC) (
						{timeOfOccurence} SMT)
					</h4>
					<h4 className="font-medium uppercase">
						Commenced Position: {placeOfBallast.startPosition.latitude} /{" "}
						{placeOfBallast.startPosition.longitude}
					</h4>
					<h4 className="font-medium uppercase">
						Stopped Position: {placeOfBallast.endPosition.latitude}/
						{placeOfBallast.endPosition.longitude}
					</h4>
				</>
			);
		}
		if (placeOfBallast.place === "AT_RECEPTION_FACILITY") {
			let {
				receiptNumber,
				receptionFacilityName,
				portName,
				receiptAttachment,
			} = placeOfBallast;
			return (
				<h4 className="font-medium uppercase">
					<h4 className="font-medium uppercase">
						Time of Occurrence: {utcTime.format("HH:mm")} hrs (UTC) (
						{timeOfOccurence} SMT)
					</h4>
					<ul>
						<li>Port: {portName}</li>
						<li>Reception Facility : {receptionFacilityName}</li>
						<li>Receipt: {receiptNumber}</li>
						<li>Attachment: {receiptAttachment}</li>
					</ul>
				</h4>
			);
		} else {
			return null;
		}
	}

	function renderItem27() {
		if (crbRecord.item27.tanks.length > 0) {
			const totalQuantityDischarged = crbRecord.item27.tanks.reduce<number>(
				(result, tank) => commonUtils.addUp(tank.transferQuantity, result),
				0
			);
			return (
				<>
					<table className="min-w-full table-auto border-collapse">
						<thead className="bg-gray-600">
							<tr>
								<th className="px-4 py-2 border text-center">Tank</th>
								<th className="px-4 py-2 border text-center">
									Discharge Quantity
								</th>
								<th className="px-4 py-2 border text-center">Catgeory</th>
								<th className="px-4 py-2 border text-center">Substance</th>
							</tr>
						</thead>
						<tbody>
							{crbRecord.item27.tanks.map((tank) => {
								return (
									<tr key={tank.selectedTank.id}>
										<td className="px-4 py-2 border text-center">
											{tank.selectedTank.tankCode}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.transferQuantity}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.catgeory}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.substance}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<br />
					<h4 className="font-medium uppercase">
						Total Ballast Discharged: {totalQuantityDischarged.toFixed(2)} M³
					</h4>
				</>
			);
		}
		return <>----</>;
	}

	function renderItem28() {
		return (
			<h4 className="font-medium uppercase">
				Circumstance of Discharge: {crbRecord.item28.circumstances}
			</h4>
		);
	}

	return renderMain();
}

export default CRBI1Preview;
